var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoxOpen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.858 6.796a.98.98 0 0 1 1.008-.537L19.997 8.15 35.13 6.26a.998.998 0 0 1 1.008.537l2.577 5.156a1.98 1.98 0 0 1-1.224 2.787l-10.1 2.887a1.974 1.974 0 0 1-2.237-.884L19.997 8.15l-5.155 8.592a1.974 1.974 0 0 1-2.238.884L2.51 14.74a1.976 1.976 0 0 1-1.223-2.787l2.571-5.156Zm16.207 5.31 3.394 5.65a3.956 3.956 0 0 0 4.481 1.768l7.881-2.25v10.322c0 1.36-.927 2.547-2.25 2.881l-12.615 3.152c-.631.161-1.292.161-1.917 0L6.423 30.477a2.986 2.986 0 0 1-2.25-2.887V17.268l7.888 2.256a3.96 3.96 0 0 0 4.481-1.768l3.387-5.65z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoxOpen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/box-open.07b9ba568292d8504ff01b6b575dcd14.svg";